<template>
    <div class="page-wrap">
        <div style="width:100%" class="loginwrap">
            <el-row :gutter="20" type="flex" justify="space-between" align="bottom">
                <el-col :span="24">
                    <h2>Forgot your password?</h2>
                </el-col>
            </el-row>
            <restore-form
                v-if="showMessage===false"
                :errors="authErrors"
                :loading="loading"
                @submit="onSubmit"
            />
            <p class="orangetext" v-else>
                {{ showMessage }}
            </p>
        </div>
    </div>
</template>

<script>
import RestoreForm from './RestoreForm'
import userApi from '../api'

export default {
    name: 'Forgot',
    components: {RestoreForm},
    data() {
        return {
            authErrors: {},
            loading: false,
            showMessage: false
        }
    },
    mounted: function () {
        if (this.$auth.user()) {
            this.redirectLogin();
        }
    },
    methods: {
        onSubmit(resetPasswordData) {
            this.loading = true
            userApi.resetPassword(resetPasswordData).then(r => {
                if (r && r.data && r.data.status) {
                    this.showMessage = r.data.status;
                } else {
                    this.$message.error('The token you are using might be expired. Please start the process of password restoration again.');
                }
            }).catch((err) => {
                this.$message.error('The token you are using might be expired. Please start the process of password restoration again.');
            }).finally(() => {
                this.loading = false;
            })
        }
    }
}
</script>

<style scoped lang="scss">

</style>
